export interface ScheduleZones {
  displayZone?: string;
  ruleZone?: string;
  dayZone?: string;
}

// The rule follows the schedule's own zone whatever the flag; only showing it waits for the flag. A schedule with
// no zone of its own keeps a UTC start but reads its weekday in the organisation's zone, as the anchoring command does.
export const scheduleZones = (timezone: string | null, zoneIsDefault: boolean, displayed: boolean): ScheduleZones => {
  const displayZone = displayed && timezone ? timezone : undefined;
  const ruleZone = timezone && !zoneIsDefault ? timezone : undefined;
  return { displayZone, ruleZone, dayZone: ruleZone ?? displayZone };
};
